<template>
  <div class="about">
    <div class="about-l">
      <div class="about-l-top">
        <p>CONTACT US</p>
        <p>联系我们</p>
      </div>
      <div class="about-l-menu">
        <p class="about-l-menu-item">联系我们</p>
        <!-- <div class="info-div">
          <div class="info-div-title">
            <i class="el-icon-phone"></i>
            <span>服务热线</span>
          </div>
          <p class="info-div-phone">0571-88026052</p>
          <div class="info-div-content">
            <p> 地址：容桂龙涌口村委会新龙工业区4号首层之二 </p>
            <p> 手机：13000000XXX </p>
            <p> 电话：0777-2361XXX </p>
            <p> 邮箱：1270XXXX@qq.com </p>
          </div>

        </div> -->
      </div>
    </div>
    <div class="about-r">
      <div class="about-r-box">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>联系我们</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="contact-box">
          <p class="p-title">万博云信（北京）​教育科技有限公司​​</p>
          <p>联系电话：189 1165 6408 / 135 2057 3697</p>
          <!-- <p>联 系 人：陈先生</p> -->
          <p>公司邮箱：lijie@vanber.cn</p>
          <!-- <p>公司传真：020-6668XXXX</p> -->
          <!-- <p>邮政编码：100000</p> -->
          <p>公司地址：北京市海淀区苏州街3号 / 浙江省杭州市学府街515号智慧谷803</p>
        </div>
        <!-- <div id="companyAddress">

        </div> -->
      </div>

    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import Swipe from './swipe.vue';
// import Content from './Contentt.vue';
import loadBMap from '../assets/js/loadBMap.js';

export default {
  name: 'Home',
  data() {
    return {
      proList: [],
      mapId: 'BMap-' + parseInt(Date.now() + Math.random()),
      myMap: null,
    };
  },
  components: {},
  created() {
    // if (!this.$store.state.token) {
    //   this.$router.push({
    //     path: '/login'
    //   });
    // }
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    // this.initMap();
  },
  methods: {
    initMap() {
      loadBMap('4xKvfK44F83ppTFM11GYZ41YMakwWTWv')
        .then(() => {
          // 百度地图API功能
          this.myMap = new BMap.Map('companyAddress'); // 创建Map实例
          var point = new BMap.Point(120.377663, 30.316767);
          this.myMap.centerAndZoom(point, 16); // 初始化地图,设置中心点坐标和地图级别
          var marker = new BMap.Marker(point); // 创建标注
          var content =
            '<div style="margin:0;line-height:20px;padding:2px;">' +
            '<img src="../img/baidu.jpg" alt="" style="float:right;zoom:1;overflow:hidden;width:100px;height:100px;margin-left:3px;"/>' +
            '地址：北京市海淀区上地十街10号<br/>电话：(010)59928888<br/>简介：百度大厦位于北京市海淀区西二旗地铁站附近，为百度公司综合研发及办公总部。' +
            '</div>';
          var searchInfoWindow = null;
          searchInfoWindow = new BMapLib.SearchInfoWindow(this.myMap, content, {
            title: '百度大厦', //标题
            width: 290, //宽度
            height: 105, //高度
            panel: 'panel', //检索结果面板
            enableAutoPan: true, //自动平移
            searchTypes: [
              BMAPLIB_TAB_SEARCH, //周边检索
              BMAPLIB_TAB_TO_HERE, //到这里去
              BMAPLIB_TAB_FROM_HERE, //从这里出发
            ],
          });
          searchInfoWindow.open(marker);

          // marker.addEventListener('click', function (e) {});

          this.myMap.addOverlay(marker); // 将标注添加到地图中
          marker.setAnimation(BMAP_ANIMATION_BOUNCE);
          // this.myMap.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
          // this.myMap.setHeading(64.5);
          // this.myMap.setTilt(73);
          //添加地图类型控件
          // this.myMap.addControl(
          //   new BMap.MapTypeControl({
          //     mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP],
          //   })
          // );
          console.log(this.myMap);
          // this.myMap.setCurrentCity('北京') // 设置地图显示的城市 此项是必须设置的
          // this.myMap.enableScrollWheelZoom(true) //开启鼠标滚轮缩放
        })
        .catch((err) => {
          console.log('地图加载失败');
        });
    },
    async getProvince() {
      let result = await this.$api.instance.getProvince();
      console.log(result);
    },
    async getEducation() {
      let result = await this.$api.instance.getEducation();
      console.log(result);
    },
    async getStudentApply() {
      let params = {
        page: 1,
        size: 100,
      };
      let result = await this.$api.instance.getStudentApply(params);
      console.log(result);
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-breadcrumb {
  font-size: 15px;
  padding: 0 0 16px;
  border-bottom: 1px solid #a5a3a35c;
}
.about {
  width: 1200px;
  min-height: 500px;
  margin: 0 auto;
  display: flex;
  .about-l {
    width: 20%;
    &-top {
      height: 152px;
      background-image: url('../assets/image/xt_bg.jpg');
      position: relative;
      margin-top: -80px;
      z-index: 2;
      color: #fefefe;
      p:first-child {
        font-size: 20px;
        padding-top: 48px;
      }
      p:last-child {
        font-size: 26px;
        font-weight: bold;
        margin-top: 2px;
      }
    }
    &-menu {
      .info-div {
        margin-top: 4px;
        // height: 220px;
        border: 1px solid #7ba6f51f;
        background: #f1f1f7;
        text-align: left;
        padding: 16px 16px 32px;
        &-title {
          height: 24px;
          line-height: 24px;
          i {
            padding: 2px;
            border: 1px solid #71a2fe;
            color: #7aa6ff;
            border-radius: 14px;
            font-size: 18px;
            margin-right: 8px;
          }
          span {
            vertical-align: top;
            font-size: 15px;
            color: #4b4b4c;
          }
        }
        &-phone {
          font-size: 24px;
          margin-top: 8px;
          color: #6e9cfe;
          font-weight: bold;
          letter-spacing: 1.5px;
        }
        &-content {
          font-size: 12px;
          color: #4b4b4c;
          padding-top: 16px;
          margin-top: 16px;
          border-top: 1px dashed #7ba6f51f;
          p + p {
            margin-top: 8px;
          }
        }
      }
      &-item {
        cursor: pointer;
        margin-top: 2px;
        padding: 16px;
        background: #a2c2fd;
        color: #fff;
      }
      &-item:hover {
        background: #3d86e0;
      }
    }
  }
  .about-r {
    width: 80%;
    &-box {
      padding: 24px;
      height: calc(100% - 48px);
      .contact-box {
        padding: 24px;
        background: url('../assets/image/contact_bgx.jpg');
        height: 252px;
        background-position: 55%;
        margin-top: 24px;
        text-align: left;
        color: #666;
        font-size: 14px;
        letter-spacing: 1.5px;
        .p-title {
          margin-top: 24px;
          margin-bottom: 16px;
          font-size: 18px;
          color: #333;
          font-weight: bold;
        }
        p {
          margin-top: 4px;
          color: #3e3d3d;
        }
      }
      #companyAddress {
        height: 380px;
        border: 1px dashed #ccc;
      }
    }
  }
  // background: #acbfa8;
}
</style>
